import React from "react";
import Meta from "../components/global/meta";
import Four0Four from "../components/404";
import Loader from "../components/global/loader";
import { useCms } from "../hooks/useCms";
import PageComponent from "../components/cms/blocks/pageComponent";
import Post from "./post";
import PressroomArticle from "./pressroomArticle";
import { GlobalStore } from "../stores/global";

export default function Page() {
  const cmsContent = useCms();
  const closeTopBanner = GlobalStore.useState(s => s.closeTopBanner);

  if (cmsContent === undefined) return <Loader withMargins />;
  if (cmsContent === null) return <Four0Four />;

  const blogPosts = cmsContent?.posts;
  const pressroomArticles = cmsContent?.pressroomArticles;

  if (blogPosts?.length) return <Post content={blogPosts.length && blogPosts[0]} />;
  else if (pressroomArticles?.length)
    return <PressroomArticle content={pressroomArticles.length && pressroomArticles[0]} />;
  else
    return (
      <div id="page" className={`${closeTopBanner ? "closeBanner" : ""}`}>
        <Meta title={cmsContent.title} seo={cmsContent.meta?.seo} />
        <div className="centralContainer">
          <PageComponent components={cmsContent.content} />
        </div>
      </div>
    );
}
